import { ScrollArea } from "@/components/ui/scroll-area";
import AgendaItem from "@/domain/entities/agenda/AgendaItem";
import useGetUserProfile from "@/hooks/useGetUserProfile";
import { cn } from "@/lib/utils";
import { useEffect } from "react";
import EventContentFooter from "./EventContentFooter";
import EventDetails from "./EventDetails";

export enum EventContentVariant {
    CALENDAR = "calendar",
    VISTASSISTANT = "vistassistant",
}

interface EventContentProps {
    updatedEvent: AgendaItem;
    editionEnabled: boolean;
    setUpdatedEvent: (updatedEvent: AgendaItem) => void;
    setIsEditing?: (isEditing: boolean) => void;
    variant?: EventContentVariant;
}

const EventContent = ({
    updatedEvent,
    editionEnabled,
    setUpdatedEvent,
    setIsEditing,
    variant,
}: EventContentProps) => {
    const { data: user } = useGetUserProfile();

    useEffect(() => {
        if (updatedEvent?.isNewEvent()) {
            setIsEditing?.(true);
        }
    }, [updatedEvent]);

    if (!user) {
        return null;
    }

    return (
        <div
            className={cn(
                "h-full",
                variant === EventContentVariant.VISTASSISTANT &&
                    "flex h-full flex-col justify-between text-left",
            )}
        >
            <div className="flex h-full flex-1 flex-col">
                <h1
                    className={cn(
                        "mt-2 py-2 pl-6 pr-10 text-xl font-semibold",
                        updatedEvent.isCancelled && "line-through",
                    )}
                >
                    {updatedEvent.subject}
                </h1>
                <ScrollArea className="my-1 mr-1 flex-1 px-6 py-2">
                    <div
                        className={cn(
                            "max-h-[650px]",
                            variant === EventContentVariant.VISTASSISTANT &&
                                "max-h-[350px]",
                        )}
                    >
                        <EventDetails event={updatedEvent} />
                    </div>
                </ScrollArea>
            </div>
            <EventContentFooter
                editionEnabled={editionEnabled}
                setIsEditing={setIsEditing}
                setUpdatedEvent={setUpdatedEvent}
                updatedEvent={updatedEvent}
                user={user}
            />
        </div>
    );
};

export default EventContent;
